import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar, ActionLink, Panel, HtmlRender} from 'shared/components';

const InterviewInviteActionSummary = observer(({entry, detailsState, candidate}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      {entry.user && <Avatar employee={entry.user} size='sm' />}
      <div className='flex-1'>
        <div className='flex justify-between'>
          <div>
            <div className='flex items-center gap-2'>
              <div className='h3 medium'>
                <FormattedMessage id={`recruiting.hiring_funnel.interview_invite_actions.${entry.action}`}/>
              </div>
              <div className='h5 jumbo'>{entry.date}</div>
            </div>
            {entry.user && <div className='h5 jumbo'>{entry.name}</div>}
          </div>
          {(entry.interviewInvite.canPatch || entry.interviewInvite.canDelete) && <div>
            <ActionLink className='dropdown'>
              <i className='material-icons submarine align-middle' data-toggle='dropdown'>{'more_horiz'}</i>
              <ul className='dropdown-menu right-0'>
                <li>
                  {entry.interviewInvite.canPatch && <div onClick={() => detailsState.openInterviewInviteModal(entry.interviewInvite)} className='py1 px3 regular jumbo clickable'>
                    <FormattedMessage id='recruiting.hiring_funnel.Edit'/>
                  </div>}
                  {entry.interviewInvite.canDelete && <div onClick={() => detailsState.openDestroyInterviewInviteModal(entry.interviewInvite)} className='py1 px3 regular jumbo clickable whitespace-nowrap'>
                    <FormattedMessage id='recruiting.hiring_funnel.Cancel invite'/>
                  </div>}
                </li>
              </ul>
            </ActionLink>
          </div>}
        </div>
        <div className='pt2'>
          <div className='h3'>{entry.interviewInvite.scheduleName}</div>
          <div>
            <FormattedMessage
              id='recruiting.hiring_funnel.INTERVIEWERS'
              values={{interviewers: entry.interviewInvite.interviewerNames}}
            />
          </div>
          <div>
            <FormattedMessage
              id='recruiting.hiring_funnel.INVITE_WINDOW'
              values={{startDate: entry.interviewInvite.formattedStartDate, endDate: entry.interviewInvite.formattedEndDate}}
            />
          </div>
          <div>
            <FormattedMessage
              id='recruiting.hiring_funnel.DURATION'
              values={{hours: Math.floor(entry.interviewInvite.interviewSchedule.duration / 60), minutes: entry.interviewInvite.interviewSchedule.duration % 60}}
            />
          </div>
        </div>
        {entry.body && <div className='mt3'>
          <Panel.Separator/>
          <div className='h3 word-break flex justify-content-between'>
            <span className='medium'>{entry.subject}</span>
            {entry.status && <span className={`h5 jumbo px1 ${entry.statusColour}`}>
              <FormattedMessage id={`recruiting.hiring_funnel.email_status.${entry.status}`}/>
            </span>}
          </div>
          <div className='h5 jumbo'>
            <FormattedMessage id='recruiting.hiring_funnel.SENDER' values={{from: entry.name}}/>
          </div>
          <div className='h5 jumbo'>
            <FormattedMessage id='recruiting.hiring_funnel.RECEIVER' values={{to: candidate.name}}/>
          </div>
          <HtmlRender className='max-height-500' html={entry.body}/>
        </div>}
      </div>
    </div>
  );
});

export default InterviewInviteActionSummary;
